import { AnalyticsEvent } from "@adsk/acc-issues-core/utils/analytics/analyticsTypes";

export class IssueEditBulkEditClickEvent implements AnalyticsEvent {
  name = "issue.edit.bulk_edit.click";
  parameters = { numberOfIssues: 0 };
}
